import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { WebtrekkConfigService } from 'src/app/webtrekk-config.service';

@Injectable({ providedIn: 'root' })
export class DocumnetWebtrekkTrackingService {
    private platformId = inject(PLATFORM_ID);


    constructor(
        private webtrekk: WebtrekkConfigService) { }
    getCountryCode(): string {
        return isPlatformBrowser(this.platformId) ? window.location.pathname.split('/')[1] : '';
    }
    trackAction(name: string, currentB2bUnitSendToWebtrack: string) {
        // SSR-safe
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }
        const actionName = `NA_Document_Download__${name}`;

        this.webtrekk.runWhenReady(() => {
            (window as any).wtSmart?.action?.data?.set({
                name: actionName,
                parameter: {
                    7: this.getCountryCode(),
                    8: currentB2bUnitSendToWebtrack
                }
            });
            (window as any).wtSmart?.track();
        })
    }
}
